import { api } from './axios'
import type {
  CreateUserDTO,
  CreateUserResponse,
  DisableMfaResponseDTO,
  EnableMfaResponseDTO,
  GetMeResponse,
  LoginDTO,
  LoginResponse,
  MfaStatusResponseDTO,
  UpdateProfileDTO,
} from './types'

/**
 * User Login
 * Use this endpoint to login to the application
 */
export const loginUser = async (formData: LoginDTO): Promise<LoginResponse> => {
  const response = await api.post<LoginResponse>('/auth/login', formData)

  return response.data
}

/**
 * Get Me
 * This api gets the logged in user data in the tenant
 */
export const getCurrentUser = async (): Promise<GetMeResponse> => {
  const response = await api.get<GetMeResponse>('/users/me')

  return response.data
}

/**
 * Create User by Super Admin
 */
export const createUser = async (userData: CreateUserDTO): Promise<CreateUserResponse> => {
  const response = await api.post<CreateUserResponse>('/users', userData)

  return response.data
}

/**
 * Update User Profile
 * Use this endpoint to update the current user's profile information
 */
export const updateProfile = async (profileData: UpdateProfileDTO): Promise<GetMeResponse> => {
  const response = await api.patch<GetMeResponse>('/users/profile', profileData)

  return response.data
}

/**
 * Enable MFA
 * Enable MFA for the authenticated user
 */
export const enableMfa = async (): Promise<EnableMfaResponseDTO> => {
  const response = await api.post<EnableMfaResponseDTO>('/users/me/mfa/enable')

  return response.data
}

/**
 * Disable MFA
 * Disable MFA for the authenticated user
 */
export const disableMfa = async (): Promise<DisableMfaResponseDTO> => {
  const response = await api.post<DisableMfaResponseDTO>('/users/me/mfa/disable')

  return response.data
}

/**
 * Get MFA Status
 * Retrieve current MFA status for the authenticated user
 */
export const getMfaStatus = async (): Promise<MfaStatusResponseDTO> => {
  const response = await api.get<MfaStatusResponseDTO>('/users/me/mfa/status')

  return response.data
}
